import { EU_REGION_ID, CN_REGION_ID } from '../static/Constants';
export const convertValue = (value: number, region: string) => {
  if (region === EU_REGION_ID) {
    return (((value / 100) * 60) / 15.6);
  } else if (region === CN_REGION_ID) {
    return (((value / 100) * 74) / 37);
  } else {
    return value;
  }
};